import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  assetOneStyling: { bottom: scale(-110), position: 'absolute', zIndex: -2 },
  assetTwoStyling: {
    alignSelf: 'center',
    position: 'absolute',
    right: scale(42),
    top: scale(28),
  },
  cardContentSrnStyle: { color: colors.neutral.charcoal, fontSize: scale(12), marginTop: scale(2) },
  cardContentStyle: { color: colors.neutral.charcoal, fontSize: scale(12), width: '90%' },
  cardTitleStyle: { color: colors.neutral.charcoal, fontSize: scale(14), marginVertical: scale(7) },
  closeStyle: {
    alignSelf: 'flex-start',
    flexDirection: 'row',
    justifyContent: 'center',
    marginLeft: scale(15),
  },
  collapsibleContainer: {
    backgroundColor: colors.neutral.mist,
    borderRadius: scale(12),
    marginBottom: scale(10),
    marginHorizontal: scale(14),
    marginTop: scale(5),
    paddingHorizontal: scale(10),
  },
  contentCardContainer: { flexDirection: 'row', paddingVertical: scale(10) },
  contentScrollStyle: {
    flex: 1,
    height: 0,
    paddingBottom: scale(40),
    paddingHorizontal: scale(16),
  },
  loginButtonStyle: {
    alignSelf: 'center',
    backgroundColor: colors.primary.carnation,
    borderRadius: scale(30),
    bottom: scale(14),
    color: colors.blackColor,
    elevation: 0,
    justifyContent: 'flex-end',
    paddingVertical: scale(10),
    position: 'absolute',
    width: '85%',
  },
  loginButtonTextStyle: { textTransform: 'none' },
  mainContainer: { backgroundColor: colors.secondary_orchid, flex: 1 },
  mainContentStyle: {
    backgroundColor: colors.neutral.cotton,
    flexGrow: 1,
    paddingBottom: scale(50),
  },
  scrollableContainerStyle: { backgroundColor: colors.neutral.cotton, paddingBottom: scale(17), paddingTop: scale(10) },
  subtermsContainerStyle: {
    backgroundColor: colors.neutral.cotton,
    borderRadius: scale(12),
    marginTop: scale(10),
    paddingBottom: scale(12),
    paddingTop: scale(8),
  },
  termsLinkStyle: { color: colors.secondary.orchid, textDecorationLine: 'underline' },
  termsTextStyle: {
    // fontSize: scale(14),
    paddingLeft: scale(8),
  },
  textContainer: { marginLeft: scale(15), marginTop: scale(20), width: '50%' },
  textStyling: { color: colors.neutral.cotton, fontSize: scale(15) },
  titleStyle: { color: colors.neutral.cotton, marginLeft: scale(10), marginTop: scale(4) },
  upperContainer: { paddingTop: scale(15) },
});

export default styles;
